module.exports = __webpack_public_path__ + "static/media/App icon Margins.b93f685a.png";